import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerSet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <path
      style={{
        fill: "#afcbd7",
      }}
      d="M9.3 9.5c0 .4.1.8.2 1.2 2.3 0 4.3-1.9 4.3-4.3 0-.4-.1-.8-.2-1.2-2.4.1-4.3 2-4.3 4.3z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M13.5 5C11 5 9 7 9 9.5s2 4.5 4.5 4.5S18 12 18 9.5 16 5 13.5 5zm0 8c-1.9 0-3.5-1.6-3.5-3.5S11.6 6 13.5 6 17 7.6 17 9.5 15.4 13 13.5 13z"
    />
    <path
      style={{
        fill: "#367e9c",
      }}
      d="M9.5 2C7 2 5 4 5 6.5S7 11 9.5 11 14 9 14 6.5 12 2 9.5 2zm0 8C7.6 10 6 8.4 6 6.5S7.6 3 9.5 3 13 4.6 13 6.5 11.4 10 9.5 10z"
    />
  </svg>
);
const Memo = memo(SvgSchemaViewerSet);
export default Memo;
